// Exact provider previews only. No PII, persisted storage or invoice requests.
export class RubQuotes {
  constructor(api, { ttl = 15000, clock = () => Date.now() } = {}) {
    this.api = api;
    this.ttl = ttl;
    this.clock = clock;
    this.values = new Map();
    this.pending = new Map();
  }
  key(body) { return JSON.stringify([body.target_currency, body.rub_amount ?? null, body.crypto_amount ?? null]); }
  peek(body) {
    const saved = this.values.get(this.key(body));
    return saved && saved.expires > this.clock() ? saved.value : null;
  }
  get(body) {
    const key = this.key(body), cached = this.peek(body);
    if (cached) return Promise.resolve(cached);
    if (this.pending.has(key)) return this.pending.get(key);
    const pending = this.api.post('/rub-topup/quote', body, { timeout: 14000 })
      .then(({ data }) => {
        if (this.values.size >= 32) this.values.delete(this.values.keys().next().value);
        this.values.set(key, { value: data, expires: this.clock() + this.ttl });
        return data;
      }).finally(() => this.pending.delete(key));
    this.pending.set(key, pending);
    return pending;
  }
  async prefetch(bodies, cancelled = () => false) {
    const queue = [...bodies];
    const worker = async () => {
      while (queue.length && !cancelled()) {
        try { await this.get(queue.shift()); } catch { /* foreground provides retry */ }
      }
    };
    await Promise.all([worker(), worker()]);
  }
}
